/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/TipDialog',['lodash', 'pixi', 'absolute/coords', 'absolute/screenmetrics', 'absolute/stringmanager',
        'MenuUI/MsftButton', 'MenuUI/MsftToggleButton', 'MenuUI/ControlFocusManager', 'util/CustomWordWrapper',
        'Managers/ScaleManager', 'absolute'],
    function (_, PIXI, Coords, ScreenMetrics, _s, MsftButton, MsftToggleButton,
              ControlFocusManager, CustomWordWrapper, ScaleManager, Absolute) {
        "use strict";

        var TipDialog = function (tipEventArgs, config, onClickClose, onToggleAlerts) {

            var defaultConfig = {
                text: '',
                letterStyle: {
                    font: "bold " + ScreenMetrics.getResScale() * 20 + "px Arial",
                    fontFamily: 'segoe',
                    fill: '#ffffff',
                    align: 'left'
                },
                buttonLetterStyle: {
                    font: "bold " + ScreenMetrics.getResScale() * 24 + "px Arial",
                    fontFamily: 'segoe',
                    fill: '#ffffff',
                    align: 'left'
                }
            };
            this.initTipDialog(tipEventArgs, _.extend(defaultConfig, config), onClickClose, onToggleAlerts);
        };

        TipDialog.constuctor = TipDialog;
        TipDialog.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);

        TipDialog.prototype.initTipDialog = function (tipEventArgs, config, onClickClose, onToggleAlerts) {
            PIXI.DisplayObjectContainer.call(this);


            // get the text
            var message = _s(tipEventArgs.TipId, tipEventArgs.Args);

            this.config = config;

            var labelText = new PIXI.Text(message, this.config.letterStyle);
            labelText.style.wordWrap = true;
            labelText.style.wordWrapWidth = Coords.x(480);

            labelText.x = Coords.x(30);
            labelText.y = Coords.y(20);
            this.message = message;
            this.labelText = labelText;
            this.addChild(labelText);
            CustomWordWrapper.doTextCustomWrap(
                labelText, _s.extractNumbersFromString(labelText.style.font), 'bold', Coords.x(500), Coords.y(90)
            );
            this.removeChild(labelText);

            var background = new PIXI.Graphics();
            background.beginFill(0);
            background.drawRect(0, 0, Coords.x(850), labelText.y + labelText.height + Coords.y(120));
            background.endFill();

            background.buttonMode = false;
            background.interactive = true;
            background.hitArea = new PIXI.Rectangle(0, 0, Coords.x(540), labelText.y + labelText.height + Coords.y(100));
            background.mouseup = background.mousedown = background.touchstart = function () {
            };

            this.background = background;
            this.backgroundWidth = this.background.width;
            this.backgroundHeight = this.background.height;

            var closeButton = new MsftButton({
                action: function () {
                    if (typeof onClickClose == 'function') onClickClose();
                }.bind(this),
                text: _s("buttons.close"),
                width: Coords.x(156),
                height: Coords.y(45),
                minHeight: Coords.y(60),
                letterStyle: this.config.buttonLetterStyle,
                threeSlice: {
                    multistate: true,
                    images: {
                        left: 'MS_3slice_btn_black_01.png',
                        center: 'MS_3slice_btn_black_02.png',
                        right: 'MS_3slice_btn_black_03.png'
                    }
                }
            });

            this.addChild(background);

            closeButton.y = this.background.y + this.background.height - closeButton.height + Coords.x(10);
            this.closeButton = closeButton;

            var doNotShowAlerts = new MsftToggleButton(
                {
                    action: function (prefix, key, value) {
                        if (typeof onToggleAlerts == 'function') onToggleAlerts(!value);
                    }.bind(this),
                    settingPrefix: "general",
                    settingsKey: "showAlerts",
                    text: '',
                    setting: false,
                    letterStyle: {
                        font: "bold " + ScreenMetrics.getResScale() * 16 + "px Arial",
                        fontFamily: 'segoe',
                        fill: '#ffffff',
                        align: 'left'
                    },
                    toggleOff: 'checkbox_off.png',
                    toggleOn: 'checkbox_on.png',
                    onLabel: 'buttons.doNotShowAgain',
                    offLabel: 'buttons.doNotShowAgain',
                    toggleDot: 'noDot'
                }
            );
            this.doNotShowAlert = doNotShowAlerts;
            doNotShowAlerts.x = Coords.x(10);
            doNotShowAlerts.y = this.background.y + this.background.height - this.doNotShowAlert.height + Coords.x(10);

            this.addChild(labelText);
            this.addChild(closeButton);
            this.addChild(doNotShowAlerts);

            this.controlFocusManager = new ControlFocusManager();
            this.controlFocusManager.addControl(closeButton, true);
            this.controlFocusManager.addControl(doNotShowAlerts, true);
            ScaleManager.addElement(this, {scaleChangeSource: 'Full'});
            this.y = Coords.y(1080) - this.height - Coords.y(20);
        };

        TipDialog.prototype.handleCommand = function (command) {
            switch (command) {
                case 'Tab':
                case 'Right':
                    this.controlFocusManager.focusNextControl(1);
                    break;
                case 'ShiftTab':
                case 'Left':
                    this.controlFocusManager.focusNextControl(-1);
                    break;
                case 'Activate':
                    this.controlFocusManager.activateCurrentControl();
                    break;
            }
        };

        TipDialog.prototype.updateText = function (message) {
            this.labelText.text = message;
            this.labelText.updateText();
            this.resizeText(
                this.background.width - Coords.x(40) * ScaleManager.scaleFactorX,
                this.background.height * 0.3,
                this.config.letterStyle
            );
        };

        TipDialog.prototype.handleResize = function () {
            this.scale.set(1 / ScaleManager.scaleFactorX, 1 / ScaleManager.scaleFactorY);
            this.resize();
            this.y = ScaleManager.height - this.background.height * ScaleManager.scaleFactorY;
        };

        TipDialog.prototype.resize = function () {
            if (Absolute.Platform.isMobile()) {
                if (Absolute.ScreenMetrics.isPortrait()) {
                    this.resizeBackground((ScaleManager.width * 0.785), 200);

                    this.resizeText(
                        (ScaleManager.width * 0.785),
                        this.background.height * 0.6,
                        this.config.letterStyle
                    );
                }
                else {
                    this.resizeBackground((ScaleManager.width * 0.69), 120);

                    this.resizeText(
                        (ScaleManager.width * 0.69),
                        this.background.height * 0.4,
                        this.config.letterStyle
                    );
                }

                this.resizeDoNotShowAlert();
                this.resizeCloseButton();                
            } else {
                if (ScaleManager.scaleFactorX <= 0.4) {
                    var xCoords = 500;
                    this.resizeBackground((ScaleManager.width * 0.7), Coords.x(xCoords) * ScaleManager.scaleFactorX);
                    this.resizeDoNotShowAlert(true);
                    this.resizeCloseButton(true);
                } else if (ScaleManager.width <= this.backgroundWidth + Coords.x(20)) {
                    this.resizeBackground(
                        (ScaleManager.width - Coords.x(15)),
                        Coords.x(450) * ScaleManager.scaleFactorX);
                    this.resizeDoNotShowAlert();
                    this.resizeCloseButton();
                } else {
                    this.resizeBackground(
                        this.backgroundWidth,
                        this.backgroundHeight
                    );
                    this.resetScales();
                }
                this.resizeText(
                    this.background.width - Coords.x(40) * ScaleManager.scaleFactorX,
                    this.background.height * 0.3,
                    this.config.letterStyle
                );
            }
        };

        TipDialog.prototype.resetScales = function () {
            this.doNotShowAlert.scale.set(1, 1);
            this.closeButton.scale.set(1, 1);
            this.closeButton.x = this.background.x + this.background.width - this.closeButton.width - Coords.x(15);
            this.closeButton.y = this.background.y + this.background.height - this.closeButton.height - Coords.x(15);
            this.doNotShowAlert.x = Coords.x(10);
            this.doNotShowAlert.y = this.background.y + this.background.height - this.doNotShowAlert.height - Coords.x(10);
        };

        TipDialog.prototype.resizeText = function (width, height, letterStyle) {
            var font = _s.extractNumbersFromString(letterStyle.font);
            if (this.labelText.width > width || this.labelText.height > height) {
                _s.shrinkToFit(
                    this.labelText,
                    font,
                    '',
                    width,
                    height
                );
            } else {
                _s.enlargeText(
                    this.labelText,
                    font,
                    '',
                    width,
                    height
                );
            }
            this.labelText.style.wordWrap = true;
            this.labelText.style.wordWrapWidth = width - (2 * Coords.x(30));
            this.labelText.x = this.background.x + Coords.x(30);
            this.labelText.y = this.background.y + Coords.x(20);
        };

        TipDialog.prototype.resizeDoNotShowAlert = function () {
            var scale = 2 * Math.max(0.2, ScaleManager.scaleFactorX);

            if (Absolute.Platform.isMobile() && Absolute.ScreenMetrics.isPortrait()) {
                scale = 0.7;
            }

            this.doNotShowAlert.scale.set(scale, scale);
            this.doNotShowAlert.y = this.background.y + this.background.height - this.doNotShowAlert.height - Coords.y(10);
        };

        TipDialog.prototype.resizeCloseButton = function (resetScale) {
            var scale = resetScale ? 2.5 * Math.max(0.2, ScaleManager.scaleFactorX)
                : 2 * Math.max(0.2, ScaleManager.scaleFactorX);
            this.closeButton.scale.set(scale, scale);
            this.closeButton.y = this.background.y + this.background.height - this.closeButton.height - Coords.x(15);
            this.closeButton.x = this.background.x + this.background.width - this.closeButton.width - Coords.x(15);
        };

        TipDialog.prototype.resizeBackground = function (width, height) {
            this.background.width = width;
            this.background.height = height;
        };

        TipDialog.prototype.removeScaling = function () {
            this.visible = false;
            ScaleManager.removeElement(this);
        };

        function wrapText(bitmapText, width) {
            var inText = bitmapText.text,
                l = 0,
                out = [],
                lastSpaceIndex = 0;

            for (var i = 0; i < bitmapText.children.length; i++) {
                if (inText[i] == " ") {
                    lastSpaceIndex = i;
                }
                out.push(inText[i]);
                if (bitmapText.children[i].x - l >= width) {
                    l = bitmapText.children[lastSpaceIndex].x;
                    out[lastSpaceIndex] = "\n";
                }
            }

            return out.join("");
        }

        return TipDialog;
    });

